<template lang="html">
  <nav>
    <div class="menu-link" @click="openMenu = !openMenu">
        <span v-if="!openMenu">MENU</span><span v-else>CLOSE</span>
    </div>
    <div class="menu-list" :class="{ 'active': openMenu }" @click="openMenu = false">
        <router-link class="projects-link" :to="{ name: 'projects' }">
            <span>P</span><span>r</span><span>o</span><span>j</span><span>e</span><span>c</span><span>t</span><span>s</span>
        </router-link>
        <router-link class="editions-link" :class="{}" :to="{ name: 'editions' }">
            <span>E</span><span>d</span><span>i</span><span>t</span><span>i</span><span>o</span><span>n</span><span>s</span>
        </router-link>
        <router-link class="shop-link" :class="{}" :to="{ name: 'store' }">
            <span>R</span><span>E</span><span>A</span><span>D</span><span>Y</span>&nbsp;<span>T</span><span>O</span>&nbsp;<span>S</span><span>H</span><span>I</span><span>P</span>
        </router-link>
        <router-link class="custom-link" :class="{}" :to="{ name: 'custom' }">
            <span>C</span><span>u</span><span>s</span><span>t</span><span>o</span><span>m</span>
        </router-link>
        <router-link class="about-link" :to="{ name: 'about' }">
            <span>A</span><span>b</span><span>o</span><span>u</span><span>t</span>
        </router-link>      
    </div>
    <div v-if="$store.state.cart.length > 0" role="button" class="cart-btn" @click="$root.$emit('openCart')">CART<span>{{ $store.state.cart.length }}</span></div>
  </nav>
</template>

<script>
export default {
    data() {
        return {
            openMenu: false,
        }
    },
    methods: {
        seperate(text) {
            let arr = [...text];
            let nstr = [];
            for (var i = 0; i < arr.length; i++) {
                let string = "<span>" + arr[i] + "</span>";
                nstr.push(string);
            }
            return nstr.join("");
        }
    }
};
</script>

<style lang="scss" scoped>
nav {
  grid-column: 3 / 4;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 1300px) {
    grid-column: span 2;
  }
  @media only screen and (max-width: 768px) {
    grid-column: span 1;
    // flex-wrap: wrap;
    a {
      flex: 0 0 50%;
    }
  }
  .menu-link {
    z-index:99;
    @media only screen and (min-width:1080px) {
        display:none;
    }
  }
  .menu-list {
    @media only screen and (max-width:1080px) {
        display:none;
        &.active {
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position:fixed;
            top:0; 
            left:0;
            width:100%;
            height:100%;
            padding:1rem;
            background: rgba(255,255,255,0.9);
            margin:0;
            a {
                padding: 0.5rem 0;
            }

        }
    }
  }
  .cart-btn {
      span {
            display: inline-block;
            transform: translateY(-25%);
      }
  }
  a, div {
    flex: 0 0 auto;
    margin-left:2em;
    cursor:pointer;
    &.projects-link {
      span {
        position: relative;
        display: inline-block;
        transition: transform 0.2s ease-in-out;
      }
      &:hover,
      &.router-link-active {
        span {
          &:nth-of-type(2) {
            transform: translate(0, 0.6rem);
          }
          &:nth-of-type(4) {
            transform: translate(0, 0.4rem);
          }
          &:nth-of-type(6) {
            transform: translate(0, 0.2rem);
          }
        }
      }
    }
    &.custom-link {
      span {
        position: relative;
        display: inline-block;
        transition: transform 0.2s;
      }
      &:hover,
      &.router-link-active {
        span {
          &:nth-of-type(6) {
            transform: translate(0, 0.25rem);
          }
          &:nth-of-type(4) {
            transform: translate(0, 0.25rem);
          }
          &:nth-of-type(2) {
            transform: translate(0, 0.5rem);
          }
          &:nth-of-type(1) {
            transform: translate(0, 0.25rem);
          }
        }
      }
    }
    &.editions-link {
      span {
        position: relative;
        display: inline-block;
        transition: transform 0.2s;
      }
      &:hover,
      &.router-link-active {
        span {
          &:nth-of-type(6) {
            transform: translate(0, 0.2rem);
          }
          &:nth-of-type(4) {
            transform: translate(0, 0.2rem);
          }
          &:nth-of-type(2) {
            transform: translate(0, 0.4rem);
          }
        }
      }
    }
    &.shop-link {
      span {
        position: relative;
        display: inline-block;
        transition: transform 0.2s;
      }
      &:hover,
      &.router-link-active {
        span {
          &:nth-of-type(4) {
            transform: translate(0, 0.2rem);
          }
          &:nth-of-type(2) {
            transform: translate(0, 0.4rem);
          }
        }
      }
    }
    &.about-link {
    //   @media only screen and (max-width: 768px) {
    //     position: absolute;
    //     right: 1em;
    //     top: 1em;
    //   }
      span {
        position: relative;
        display: inline-block;
        transition: transform 0.2s;
      }
      &:hover,
      &.router-link-exact-active {
        span {
          &:nth-of-type(1) {
            transform: translate(0, 0.4rem);
          }
          &:nth-of-type(3) {
            transform: translate(0, 0.2rem);
          }
        }
      }
    }
  }
}
</style>
